import * as React from "react";
import {Link} from "react-router-dom";
import {resourcesHelper} from "@falcon/services";

interface IProps {
    smallScreenMarginRequired?: boolean,
    policyNumber: string,
}

export class InactiveDirectDebitBanner extends React.Component<IProps> {

    public render(): React.ReactNode {

        const pathName = `/dashboard/${this.props.policyNumber}/paymentDetails/editDirectDebit/`

        return (
            <div className="inner-cogntainer">
                <div className="warning-banner dashboard-missed-payment-banner mb-0">
                    <div className="w-100">
                        <div className="overflow-auto">
                            <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon"
                                 className="inline-warning-icon pt-2"/>
                            <div className="banner-text inline-warning-text">
                                You no longer have an active Direct Debit with Allianz.
                                <div>
                                    <Link id="payNow"
                                          className="d-inline text-decoration-underline cursor-pointer muli-bold-16"
                                          aria-label={"Pay Now"}
                                          to={{
                                              pathname: pathName,
                                              state: {policyNumber: this.props.policyNumber}
                                          }}>
                                        Set-up your Direct Debit</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

}



// WEBPACK FOOTER //
// ./src/components/banners/InactiveDirectDebitBanner.tsx